export default __webpack_public_path__ + "static/157-55d4f81cdec368c6279c65d4b7657d6e.gif";